import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-stack',
	templateUrl:'./StackDiagramPage.html',
	styles: [],
	styleUrls:['./StackDiagramPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class StackDiagramPage
{
	mdContent_32 = `\`\`\`mermaid
%%{init: {
  'theme': 'dark',
  'themeVariables': {
    'darkMode': true,
    'background': '#1a1a2e',
    'primaryColor': '#6366f1',
    'primaryTextColor': '#e2e8f0',
    'primaryBorderColor': '#818cf8',
    'secondaryColor': '#1e293b',
    'secondaryTextColor': '#cbd5e1',
    'secondaryBorderColor': '#475569',
    'tertiaryColor': '#0f172a',
    'tertiaryTextColor': '#94a3b8',
    'tertiaryBorderColor': '#334155',
    'lineColor': '#818cf8',
    'textColor': '#e2e8f0',
    'mainBkg': '#1e293b',
    'nodeBorder': '#818cf8',
    'clusterBkg': '#0f172a',
    'clusterBorder': '#475569',
    'titleColor': '#e2e8f0',
    'edgeLabelBackground': '#1e293b',
    'nodeTextColor': '#e2e8f0',
    'actorTextColor': '#e2e8f0',
    'actorBorder': '#818cf8',
    'actorBkg': '#1e293b',
    'actorLineColor': '#818cf8',
    'signalColor': '#818cf8',
    'signalTextColor': '#e2e8f0',
    'labelBoxBkgColor': '#1e293b',
    'labelBoxBorderColor': '#475569',
    'labelTextColor': '#e2e8f0',
    'loopTextColor': '#cbd5e1',
    'noteBkgColor': '#1e293b',
    'noteBorderColor': '#6366f1',
    'noteTextColor': '#e2e8f0',
    'activationBorderColor': '#818cf8',
    'activationBkgColor': '#1e293b',
    'sequenceNumberColor': '#1a1a2e',
    'sectionBkgColor': '#1e293b',
    'altSectionBkgColor': '#0f172a',
    'gridColor': '#334155',
    'taskBorderColor': '#818cf8',
    'taskBkgColor': '#1e293b',
    'taskTextColor': '#e2e8f0',
    'activeTaskBorderColor': '#a5b4fc',
    'activeTaskBkgColor': '#312e81',
    'doneTaskBkgColor': '#475569',
    'doneTaskBorderColor': '#64748b',
    'critBorderColor': '#f87171',
    'critBkgColor': '#7f1d1d',
    'fontFamily': 'Inter, system-ui, sans-serif',
    'fontSize': '14px'
  }
}}%%
graph TD
  subgraph APP["YOUR APPLICATION"]
    direction LR
    a1["@NgComponent"] ~~~ a2["@NgRoutable"] ~~~ a3["@NgDataService"]
  end
  subgraph PLUGINS["PLUGINS & COMPONENTS"]
    direction LR
    p1["WebAwesome"] ~~~ p2["AG Grid"] ~~~ p3["Charts"]
    p4["RabbitMQ"] ~~~ p5["Font Awesome"] ~~~ p6["Calendar"]
  end
  subgraph CORE["JWEBMP CORE"]
    direction LR
    c1["HTML Elements"] ~~~ c2["CSS Builder"] ~~~ c3["Events"]
    c4["AJAX Pipeline"] ~~~ c5["Angular Generator"] ~~~ c6["TS Compiler"]
  end
  subgraph FOUNDATION["GUICEDEE FOUNDATION"]
    direction LR
    f1["Google Guice DI"] ~~~ f2["SPI Discovery"] ~~~ f3["JPMS"]
    f4["Vert.x 5 HTTP"] ~~~ f5["Event Bus"] ~~~ f6["Call Scopes"]
  end
  APP ==> PLUGINS ==> CORE ==> FOUNDATION

  style APP fill:#312e81,stroke:#818cf8,stroke-width:2px,color:#e2e8f0
  style PLUGINS fill:#1e3a5f,stroke:#60a5fa,stroke-width:2px,color:#e2e8f0
  style CORE fill:#1a3330,stroke:#34d399,stroke-width:2px,color:#e2e8f0
  style FOUNDATION fill:#3b1a1a,stroke:#f87171,stroke-width:2px,color:#e2e8f0

\`\`\``;
}
